import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

const MultipleSelectDropdown = ({
  label,
  options = [],
  selected = [],
  onChange = () => {},
  searchable = false,
  disabled = false,
  className = "",
  placeholder = "Select..."
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleSelection = (optionValue) => {
    const updated = selected.includes(optionValue)
      ? selected.filter((val) => val !== optionValue)
      : [...selected, optionValue];
    onChange(updated);
  };

  const filteredOptions = searchable
    ? options.filter((opt) =>
        opt.label.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : options;

  return (
    <div ref={dropdownRef} className={`flex flex-col w-full ${className}`}>
      {label && (
        <label className="block text-sm font-bold text-gray-800 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          disabled={disabled}
          className={`w-full text-left px-3 py-2 border rounded-md ${
            disabled ? "bg-gray-100 cursor-not-allowed opacity-60" : "input-default"
          }`}
        >
          <div className="h-[1.5rem] overflow-hidden">
            {selected.length > 0 ? (
              selected
                .map((val) => options.find((o) => o.value === val)?.label)
                .filter(Boolean)
                .join(", ")
            ) : (
              <span className="text-gray-400">{placeholder}</span>
            )}
          </div>
          <FontAwesomeIcon
            icon={faChevronDown}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
          />
        </button>

        {isOpen && (
          <div className="absolute mt-1 w-full bg-white border rounded-md shadow-lg z-10">
            {searchable && (
              <input
                type="text"
                placeholder="Search..."
                className="input-default w-full px-2 py-1"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            )}
            <div className="max-h-64 overflow-y-auto">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <label
                    key={option.value}
                    className="flex items-center py-2 px-3 hover:bg-blue-50 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      className="custom-checkbox-input hidden"
                      checked={selected.includes(option.value)}
                      onChange={() => toggleSelection(option.value)}
                    />
                    <div className="custom-checkbox mr-2">
                      <svg
                        className="custom-checkbox-icon"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                    </div>
                    {option.label}
                  </label>
                ))
              ) : (
                <p className="text-gray-500 px-3 py-2">No options found</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MultipleSelectDropdown;
